'use client';

import { FC } from 'react';
import SectionAds from './SectionAds';
import SectionContact from './SectionContact';
import SectionFormats from './SectionFormats';
import SectionHero from './SectionHero';
import SectionKeypoints from './SectionKeypoints';
import SectionPress from './SectionPress';
import SectionStores from './SectionStores';

interface Props {
  src?: string;
}

const JoinUs: FC<Props> = ({ src }) => {
  return (
    <div className="tw-space-y-20">
      <SectionHero />
      <SectionFormats />
      <SectionPress />
      <SectionAds />
      <SectionKeypoints />
      <SectionStores />
      <SectionContact src={src} />
    </div>
  );
};

export default JoinUs;
